module.exports = __webpack_public_path__ + "img/данные аварийные.ee4ebf72.svg";